<div class="campanhas-table-scroll">
  <table class="campanhas-table" [attr.aria-label]="ariaLabel()">
    <ng-content />
  </table>
</div>
